import React, { useEffect, useState } from 'react';

const reorderList = (list, fromIndex, toIndex) => {
  const next = [...list];
  const [movedTeam] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, movedTeam);
  return next;
};

const TeamOrderConstructor = ({ isOpen, teams, onClose, onSave, isSaving }) => {
  const [localTeams, setLocalTeams] = useState(teams);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setLocalTeams(teams);
      setDraggedIndex(null);
      setDragOverIndex(null);
    }
  }, [isOpen, teams]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen && !isSaving) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, isSaving, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleDrop = (targetIndex) => {
    if (draggedIndex === null || draggedIndex === targetIndex || isSaving) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    setLocalTeams(reorderList(localTeams, draggedIndex, targetIndex));
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const moveTeam = (index, direction) => {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= localTeams.length || isSaving) {
      return;
    }
    setLocalTeams(reorderList(localTeams, index, targetIndex));
  };

  const hasChanges =
    localTeams.length !== teams.length ||
    localTeams.some((team, index) => team.name !== teams[index]?.name);

  return (
    <div className="order-constructor-overlay" onClick={onClose}>
      <div className="order-constructor-modal" onClick={(event) => event.stopPropagation()}>
        <div className="order-constructor-header">
          <div>
            <h4>🔧 Конструктор порядка команд</h4>
            <p>Перетащите мини-карточки или используйте стрелки для быстрой расстановки</p>
          </div>
          <button
            type="button"
            className="order-constructor-close"
            onClick={onClose}
            disabled={isSaving}
            aria-label="Закрыть конструктор порядка"
          >
            ✕
          </button>
        </div>

        <div className={`team-mini-list ${isSaving ? 'team-mini-list--saving' : ''}`}>
          {localTeams.map((team, index) => (
            <div
              key={team.name}
              className={`team-mini-card ${
                draggedIndex === index ? 'dragging' : ''
              } ${dragOverIndex === index ? 'drag-over' : ''}`}
              onDragOver={(event) => {
                event.preventDefault();
                if (draggedIndex !== null && draggedIndex !== index) {
                  setDragOverIndex(index);
                }
              }}
              onDrop={(event) => {
                event.preventDefault();
                handleDrop(index);
              }}
              onDragLeave={() => setDragOverIndex(null)}
            >
              <span className="team-mini-position">{index + 1}</span>
              <button
                type="button"
                className="team-drag-handle team-mini-drag-handle"
                draggable={!isSaving}
                onDragStart={() => setDraggedIndex(index)}
                onDragEnd={() => {
                  setDraggedIndex(null);
                  setDragOverIndex(null);
                }}
                title="Перетащите для изменения порядка"
                aria-label={`Изменить порядок команды ${team.name}`}
              >
                ⋮⋮
              </button>
              <div
                className="team-color-indicator team-mini-color"
                style={{ backgroundColor: team.color || '#3bbddb' }}
              />
              <span className="team-mini-name">{team.name}</span>
              <div className="team-mini-actions">
                <button
                  type="button"
                  className="team-mini-move-btn"
                  onClick={() => moveTeam(index, -1)}
                  disabled={index === 0 || isSaving}
                  title="Переместить выше"
                >
                  ↑
                </button>
                <button
                  type="button"
                  className="team-mini-move-btn"
                  onClick={() => moveTeam(index, 1)}
                  disabled={index === localTeams.length - 1 || isSaving}
                  title="Переместить ниже"
                >
                  ↓
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="order-constructor-footer">
          <button type="button" className="cancel-btn" onClick={onClose} disabled={isSaving}>
            Отмена
          </button>
          <button
            type="button"
            className="save-btn"
            onClick={() => onSave(localTeams)}
            disabled={!hasChanges || isSaving}
          >
            {isSaving ? 'Сохранение...' : '💾 Сохранить порядок'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamOrderConstructor;
